import React, { useState, useEffect } from 'react';
import './formEmployee.css'
import dayjs from "dayjs";
import { Form, Input, Button, Switch, Typography, Space, Row, Col, Select, DatePicker, InputNumber } from 'antd';
const { Text } = Typography;
const { Option } = Select

const FormEmployee = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.editEmployee();  // Llama la función de guardado
    };

    const handleCreateClick = () => {
        props.createEmployee(); // Llamamos a la función de creación
    };

    useEffect(() => {
        setIsEditing(false);
    }, [props.emplDni])

    return (
        <Form layout="horizontal">
            {/* Nombre(s) del colaborador*/}
            <Row align="middle">
                <Col span={8}><strong>Nombre(s):</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Input value={props.emplFirstName} onChange={(e) => props.setEmplFirstName(e.target.value.toUpperCase())} />
                    ) : (
                        <Text>{props.emplFirstName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Apellidos del colaborador */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Apellido(s):</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Input value={props.emplLastName} onChange={(e) => props.setEmplLastName(e.target.value.toUpperCase())} />
                    ) : (
                        <Text>{props.emplLastName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Número de identificación */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Número de identificación:</strong></Col>
                <Col span={16}>
                    {props.newEmployee ? (
                        <InputNumber min={0} style={{ width: "100%" }} value={props.emplDni} onChange={(val) => props.setEmplDni(val)} />
                    ) : (
                        <Text>{props.emplDni || "No especificado"}</Text>
                    )}
                    
                </Col>
            </Row>

            {/* Correo electrónico */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Correo electrónico:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Input value={props.emplEmail} onChange={(e) => props.setEmplEmail(e.target.value)} />
                    ) : (
                        <Text>{props.emplEmail || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Fecha de nacimiento */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Fecha de nacimiento:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <DatePicker
                            value={props.emplBirthDate ? dayjs(props.emplBirthDate) : null} // Convierte la fecha a formato dayjs
                            onChange={(date, dateString) => props.setEmplBirthDate(dateString)} // Guarda la fecha en formato YYYY-MM-DD
                            format="YYYY-MM-DD" // Formato de la fecha
                            style={{ width: 200 }}
                            placeholder="Selecciona una fecha"
                        />
                    ) : (
                        <Text>{props.emplBirthDate || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Género */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Género:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Select style={{width: "100%"}} value={props.emplGender} onChange={(value) => props.setEmplGender(value)}>
                            <Option value="F">FEMENINO</Option>
                            <Option value="M">MASCULINO</Option>
                            <Option value="N">NO ESPECIFICADO</Option>
                        </Select>
                    ) : (
                        <Text>{props.emplGender === "F" ? "FEMENINO" : props.emplGender === "M" ? "MASCULINO" : "NO ESPECIFICADO"}</Text>
                    )}
                </Col>
            </Row>

            {/* Sede */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Sede:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Select 
                            showSearch 
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            style={{width: "100%"}} 
                            value={props.emplOrganizationHqId} 
                            onChange={(value) => props.setEmplOrganizationHqId(value)}
                        >
                            {
                                props.organizationHqs.map((ohq, x) => {
                                    return <Option key={x} value={ohq.ohq_id}>{ohq.ohq_location}</Option>
                                })
                            }
                        </Select>
                    ) : (
                        <Text>{props.emplOrganizationHqName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Gerencia */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Gerencia:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Select 
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            style={{width: "100%"}} 
                            value={props.emplManagementAreaId} 
                            onChange={(value) => props.setEmplManagementAreaId(value)}
                        >
                            {
                                props.managementAreas.map((mna, x) => {
                                    return <Option key={x} value={mna.mna_id}>{mna.mna_management_area}</Option>
                                })
                            }
                        </Select>
                    ) : (
                        <Text>{props.emplManagementAreaName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Área */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Área:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Select 
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            style={{width: "100%"}} 
                            value={props.emplAreaId} 
                            onChange={(value) => props.setEmplAreaId(value)}
                        >
                            {
                                props.areas.map((area, x) => {
                                    return <Option key={x} value={area.area_id}>{area.area_area}</Option>
                                })
                            }
                        </Select>
                    ) : (
                        <Text>{props.emplAreaName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Categoría del cargo */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Categoría del cargo:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Select 
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            style={{width: "100%"}} 
                            value={props.emplJobCategoryId} 
                            onChange={(value) => props.setEmplJobCategoryId(value)}
                        >
                            {
                                props.jobCategories.map((jct, x) => {
                                    return <Option key={x} value={jct.jct_id}>{jct.jct_category}</Option>
                                })
                            }
                        </Select>
                    ) : (
                        <Text>{props.emplJobCategoryName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Cargo */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Cargo:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Select 
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            style={{width: "100%"}} 
                            value={props.emplJobTitleId} 
                            onChange={(value) => props.setEmplJobTitleId(value)}
                        >
                            {
                                props.jobTitles.map((jtt, x) => {
                                    return <Option key={x} value={jtt.jtt_id}>{jtt.jtt_title}</Option>
                                })
                            }
                        </Select>
                    ) : (
                        <Text>{props.emplJobTitleName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>


            {/* Fecha de ingreso */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Fecha de ingreso:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <DatePicker
                            value={props.emplEntryDate ? dayjs(props.emplEntryDate) : null} // Convierte la fecha a formato dayjs
                            onChange={(date, dateString) => props.setEmplEntryDate(dateString)} // Guarda la fecha en formato YYYY-MM-DD
                            format="YYYY-MM-DD" // Formato de la fecha
                            style={{ width: 200 }}
                            placeholder="Selecciona una fecha"
                        />
                    ) : (
                        <Text>{props.emplEntryDate || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Estado Activo */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Activo:</strong></Col>
                <Col span={16}>
                    {isEditing || props.newEmployee ? (
                        <Switch checked={props.emplActive} onChange={props.setEmplActive} />
                    ) : (
                        <Text>{props.emplActive ? "Sí" : "No"}</Text>
                    )}
                </Col>
            </Row>

            {/* Botones */}
            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {props.newEmployee ? (
                        // Si es un nuevo empleado, solo mostrar "Crear"
                        <Button type="primary" onClick={handleCreateClick}>Guardar</Button>
                    ) : isEditing ? (
                        // Si está editando, mostrar "Guardar" y "Cancelar"
                        <>
                            <Button type="primary" onClick={handleSaveClick}>Guardar</Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        // Si no está editando ni es nuevo, mostrar "Editar"
                        <Button type="default" onClick={handleEditClick}>Editar</Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormEmployee;
